import { graphql } from "gql";

const GET_ORGANIZATION_ID = graphql(`
  query GetOrganizationId($organizationName: String!) {
    organizationId(organizationName: $organizationName) {
      id
      name
    }
  }
`);

const GET_ORGANIZATION_DATA = graphql(`
  query GetOrganizationData(
    $canGetGroups: Boolean!
    $organizationName: String!
  ) {
    me {
      userEmail
      tags(organizationName: $organizationName) {
        name
        groups @include(if: $canGetGroups) {
          name
        }
      }
    }
    organizationId(organizationName: $organizationName) {
      id
      hasZtnaRoots
      name
      permissions
    }
  }
`);

const GET_ORGANIZATION_GROUPS_FINDINGS = graphql(`
  query GetOrganizationGroupsFindings($organizationId: String!) {
    organization(organizationId: $organizationId) {
      name
      groups {
        name
        findings {
          id
          title
        }
      }
    }
  }
`);

export {
  GET_ORGANIZATION_DATA,
  GET_ORGANIZATION_ID,
  GET_ORGANIZATION_GROUPS_FINDINGS,
};
